





















































































































































































































































import { Component, Vue, Emit } from "vue-property-decorator";
import usuarioModule from "@/store/usuario/UsuarioModule";
import { usuarioStorage } from "@/store/usuario/UsuarioStorage";

@Component({})
export default class AuthHeader extends Vue {
  drawer = false;

  @Emit("navigate")
  navigate(route: any) {}

  logout() {
    usuarioModule
      .logout()
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        try {
          console.log(this.$router);
          this.$router.push({ name: "Login" }).catch((err) => {
            console.log(err);
          });
        } catch (err) {
          console.log(err);
        }
      });
  }

  get isAdministrador() {
    return usuarioStorage.authorities.includes("ADMINISTRADOR_ACESSO");
  }

  get isPeritoOrcamentoAuto() {
    return usuarioStorage.authorities.includes("PERITO_ORCAMENTO_AUTO_ONLINE");
  }

  get isAnalistaSaude() {
    return usuarioStorage.authorities.includes("ANALISTA_SAUDE");
  }

  get isContabilFinanceiro() {
    return usuarioStorage.authorities.includes("INTEGRACAO_CONTABIL_ACESSO");
  }

  get isAnalistaAssistencia24h() {
    return usuarioStorage.authorities.includes("ANALISTA_ASSISTENCIA_24H");
  }
}
